import BaliseService from "@/services/balise.service.js";
import BaliseFormatter from "@/helpers/formatters/balise.formatter.js";

class BaliseRepository {

    async getBalises(search = "") {
        const res = await BaliseService.getGroupBalisesLastPositions(search);
        return BaliseFormatter.balisesFormat(res.data);
    }

    async getAllBalises(filters = {}) {
        const res = await BaliseService.getAllBalises(filters);
        return BaliseFormatter.balisesFormat(res.data);
    }

    async getBalise(id) {
        const res = await BaliseService.getBaliseInfo(id);
        return BaliseFormatter.baliseFormat(res.data);
    }
}

export default new BaliseRepository();